import React from "react";
import TableView from "../../tables/TableView";
import AddNewButton from "../../buttons/AddNewButton";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Nazov", "caption": "Názov", 'filter': 'string'}
]

function ServiceCaseActions(props) {
    const baseUrl = '/service_case/service_cases_actions'
    const initialFilters = [
        {
            'label': 'Nazov',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Nazov',
        }
    ]
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Nazov': `/service_case_actions/service_case_action/${entry.id}`
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={`/service_case_actions/service_case_action`}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Druhy činnosti"}
        />
    )
}

export default ServiceCaseActions
